import { useParams } from "react-router-dom";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { categories } from "@/mocks/categories";
import { videos } from "@/mocks/videos";
import VideoBrowser from "@/components/feature/VideoBrowser";
import Breadcrumb from "@/components/feature/Breadcrumb";
import EmptyState from "@/components/base/EmptyState";
import { useNavigate } from "react-router-dom";

export default function CategoryPage() {
  const navigate = useNavigate();
  const { categorySlug } = useParams();
  const category = categories.find((item) => item.slug === categorySlug);

  useDocumentTitle(
    category ? `${category.name} - 高清视频 - 啪啪视频` : "视频分类 - 啪啪视频",
    category
      ? `${category.description} 在啪啪视频观看${category.name}类高清视频，支持按地区、上传时间与视频时长筛选。`
      : "在啪啪视频按分类浏览高清视频资源。",
    category
      ? `${category.name}视频,${category.name}高清视频,在线视频,啪啪视频`
      : "视频分类,高清视频,在线视频,啪啪视频",
  );

  if (!category) {
    return (
      <div className="mx-auto w-full max-w-[1280px] px-4 py-16 md:px-6">
        <EmptyState
          icon="ri-folder-warning-line"
          title="没有找到这个分类"
          description="该分类可能已调整或链接有误。你可以返回首页，重新选择感兴趣的视频分类。"
          actionLabel="返回首页"
          onAction={() => navigate("/")}
        />
      </div>
    );
  }

  return (
    <div className="mx-auto w-full max-w-[1280px] px-4 py-8 md:px-6">
      <Breadcrumb items={[{ label: "首页", to: "/" }, { label: category.name }]} />

      <header className="mt-4 flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-6 md:flex-row md:items-center md:justify-between">
        <div className="flex items-start gap-4">
          <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className={`${category.icon} text-2xl`}></i>
          </span>
          <div>
            <h1 className="font-heading text-2xl font-bold text-foreground-950">{category.name}视频</h1>
            <p className="mt-1.5 max-w-2xl text-sm leading-relaxed text-foreground-500">{category.description}</p>
          </div>
        </div>
        <span className="w-fit rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
          {videos.filter((video) => video.category === category.slug).length} 个视频
        </span>
      </header>

      <div className="mt-6">
        <VideoBrowser
          videos={videos}
          lockedFilter={{ category: category.slug }}
          showCategory={false}
          showTag
          emptyTitle="该分类下暂无符合条件的视频"
          emptyDescription="试着放宽地区、时间或时长筛选条件，查看更多内容。"
        />
      </div>
    </div>
  );
}